module.exports = __webpack_public_path__ + "static/img/m_name.6c276d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/ch/m_name.png
// module id = BYHS
// module chunks = 7